import { Activity } from './Contracts';
import { logNotification } from './OTelNotifications';
import { cloneEvent } from './SimpleTelemetryLogger';
// Currently we only send one activity at a time
var ACTIVITY_COUNT = 1;
// Currently we do not aggregate activities in OTelJS
var ACTIVITY_AGGMODE = 0;
var getCurrentMicroseconds = function () {
    return Date.now() * 1000;
};
if (typeof window === 'object' && typeof window.performance === 'object' && 'now' in window.performance) {
    getCurrentMicroseconds = function () {
        return Math.floor(window.performance.now()) * 1000;
    };
}
export var createActivity = function (activityProperties) {
    var _startTime = getCurrentMicroseconds();
    var _ended;
    var clonedEvent = cloneEvent(activityProperties.telemetryEvent);
    return {
        cv: activityProperties.parentCv.getNext(),
        eventName: activityProperties.telemetryEvent.eventName,
        dataFields: clonedEvent.dataFields,
        eventFlags: clonedEvent.eventFlags,
        telemetryProperties: clonedEvent.telemetryProperties,
        /**
         * Creates an activity parented to this one.
         * @param telemetryEvent - The underlying telemetry event for this activity
         */
        createChildActivity: function (telemetryEvent) {
            return createActivity({
                telemetryEvent: telemetryEvent,
                sendTelemetryEvent: activityProperties.sendTelemetryEvent,
                parentCv: this.cv
            });
        },
        /**
         * Sets the result of the activity. Does not end it.
         * @param resultCode - The result code, e.g. 0 for success
         * @param resultType - Optional: The result type, e.g. "HRESULT"
         * @param resultTag - Optional: The result tag
         */
        // tslint:disable-next-line no-reserved-keywords
        setResult: function (code, type, tag) {
            this.result = { code: code, type: type, tag: tag };
        },
        /**
         * Ends the activity; records the duration and sends a telemetry event.
         */
        endNow: function () {
            if (_ended) {
                logNotification(0 /* Error */, 0 /* Core */, function () { return 'Already ended'; });
                return;
            }
            if (this.success === undefined && this.result === undefined) {
                // The Activity dashboard shows these activities as 'unresolved'
                // but developers generally should avoid leaving activities in this state.
                logNotification(1 /* Warning */, 0 /* Core */, function () { return 'Activity does not have success or result set'; });
            }
            var endTime = getCurrentMicroseconds();
            var duration = endTime - _startTime;
            _ended = true;
            // Fill the event contract
            var activity = {
                duration: duration,
                count: ACTIVITY_COUNT,
                aggMode: ACTIVITY_AGGMODE,
                cV: this.cv.value,
                success: this.success,
                result: this.result
            };
            var newDataFields = this.eventContract && this.eventContract.dataFields ? this.eventContract.dataFields : [];
            newDataFields.push.apply(newDataFields, Activity.getFields(activity));
            this.eventContract = {
                name: Activity.contractName,
                dataFields: newDataFields
            };
            return activityProperties.sendTelemetryEvent(this);
        }
    };
};
//# sourceMappingURL=Activity.js.map